// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:33:29.909Z
// Property: The Quincy (ID: 6767906449167640)
// Collections: 22 amenities, 1 floorplans (live), 1 photos, 40 POIs, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167640",
  "property_external_id": "2461463",
  "property_zillow_url": "https://www.zillow.com/b/2005-quintasen-ct-charlotte-nc-CssFkh/",
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "18002849069",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-quincy",
  "property_name": "The Quincy",
  "property_website_url": "https://www.live-quincy.com",
  "property_domain": "https://www.live-quincy.com",
  "property_address": "2005 Quintasen Court",
  "property_full_address": "2005 Quintasen Ct, Charlotte, NC 28262",
  "property_address_1": "2005 Quintasen Court",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28262",
  "property_address_zip": "28262",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "University City North",
  "property_address_latitude": "35.334239",
  "property_address_longitude": "-80.741992",
  "property_email": "clthub@quinnmgmt.com",
  "property_phone": "(877) 509-5053",
  "property_call_tracking_phone": null,
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Modern townhome living in University City.</strong> The Quincy brings spacious three- and four-bedroom rentals with upscale finishes, two-car garages, smart-home features, and resort-style spaces—minutes from major Charlotte connections. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see what’s coming.</p>",
  "property_long_description": "<p><strong>Townhome-style space, resort-inspired ease.</strong> At The Quincy, you get a new take on Charlotte rental living: spacious three-bedroom townhomes with attached two-car garages, flex space, smart home features, luxury flooring, in-home washer and dryer, and polished kitchens with quartz countertops and efficient appliances. Beyond your front door, the community is designed for everyday balance with a pool, fitness center, clubhouse, business pods, BBQ/picnic areas, and pickleball courts—see more of the <a href=\"/amenities\">resort-inspired amenities</a> or compare available <a href=\"/floor-plans\">three-bedroom townhome layouts</a>.</p><p>In University City North, you’re close to one of Charlotte’s most active growth corridors—UNC Charlotte, University Research Park employers, Atrium Health University City, the LYNX Blue Line, I-85, I-485, and Highway 49. For dining and downtime, head to The Boardwalk at University City, explore the UNC Charlotte Botanical Gardens, or catch a show at Truliant Amphitheater; your <a href=\"/neighborhood\">University City neighborhood</a> keeps the Queen City within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
  "property_featured_image_media": {
    "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
    "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
    "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
    "width": 1920,
    "height": 450
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "327",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "20",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "100",
  "property_fees_deposit_info": "Estimated application cost $100 (one-time, due at application). Estimated move-in cost is the first month's Total Monthly Price plus $350 in one-time charges due at move-in. The Total Monthly Price ($2,635.95–$2,710.95 on the Fraser plan) includes base rent ($2,525–$2,600) plus $110.95 in mandatory monthly fees; variable and usage-based charges are excluded. The security deposit may change based on screening results but will not exceed legal maximums. Full fee schedule is in the application and lease agreement.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "No breed restrictions",
  "property_pet_policy_description": "Pets are allowed with some breed restrictions (no Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, American Bulldog, or crossbreeds). Maximum weight limit of 100 pounds per pet. No more than two pets allowed unless written approval is obtained from Quinn Property Management.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://live-quincy.securecafe.com/onlineleasing/the-quincy1/floorplans.aspx",
  "property_resident_portal_url": "https://live-quincy.securecafenet.com/residentservices/the-quincy1/userlogin",
  "property_apply_now_url": "https://live-quincy.securecafe.com/onlineleasing/the-quincy1/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/01a0cf30-e000-7679-923b-12f07b615447.webp",
  "property_primary_logo_media": {
    "alt_text": "The Quincy logo",
    "public_id": "01a0cf30-e000-7679-923b-12f07b615447",
    "storage_key": "property/6767906449167640/01a0cf30-e000-7679-923b-12f07b615447.webp",
    "width": 3072,
    "height": 905
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/01a0cf31-23f1-76ad-9333-e757660d2e86.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0cf31-23f1-76ad-9333-e757660d2e86",
    "storage_key": "property/6767906449167640/01a0cf31-23f1-76ad-9333-e757660d2e86.webp",
    "width": 1280,
    "height": 377
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/01a0cf31-1a16-73cd-9877-ee600f5ad55f.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0cf31-1a16-73cd-9877-ee600f5ad55f",
    "storage_key": "property/6767906449167640/01a0cf31-1a16-73cd-9877-ee600f5ad55f.webp",
    "width": 1280,
    "height": 377
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#8b3e07",
  "property_secondary_color": "#303644",
  "property_font_color": "#222222",
  "property_color_4": null,
  "property_color_3": "#dfdddb",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1483 - 1783",
  "property_sqft_min": "1483",
  "property_sqft_max": "1783",
  "property_price_range": "2525 - 2600",
  "property_price_min": "2525",
  "property_price_max": "2600",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61565857531683",
  "property_instagram_url": "https://www.instagram.com/livequincycharlotte",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJUXYThY8dVIgRIyfQPiMHCfI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Quincy",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Townhome",
  "property_home_amenities_blurb": "<p><strong>Townhome-style ease, resort-worthy extras.</strong> The Quincy pairs flex space, large closets, in-home laundry, 2-car garages, quartz countertops, and luxury flooring with community spaces built for every pace. Work from business pods, train in the fitness center with free weights, unwind by the pool, or connect at the clubhouse, recreation room, BBQ area, and pickleball court.</p>",
  "property_home_floorplans_blurb": "<p><strong>Three-bedroom townhome space, sharpened for everyday ease.</strong> The Quincy pairs an open main level and flexible bonus space with polished finishes like quartz countertops, luxury flooring, efficient appliances, and in-home laundry. Generous storage, a convenient half bath, and a <strong>2-car garage</strong> add function where it counts, with community amenities waiting just outside your door.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at The Quincy.</strong> Browse sunlit townhome-style interiors with quartz countertops, luxury flooring, and smart storage, then see the spaces that extend the day: pool views, a polished clubhouse, focused business pods, grilling areas, and a pickleball court ready for the next match.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected to Charlotte’s northside momentum.</strong> From The Quincy, University City North puts UNC Charlotte, University Research Park, the Blue Line, I-85, and I-485 within easy reach. Grab coffee at The Boardwalk, unwind by the lake, catch a show at Truliant Amphitheater, or get outside on Mallard Creek Greenway—then come home to townhome-style space with attached garages, flex areas, and amenities built for everyday balance.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at The Quincy.</strong> Resident feedback offers a firsthand look at the spaces, service, and everyday experience in University City North. Preview the highlights here, then explore the full reviews to compare details and plan your next step with confidence.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from a connected University City North base.</strong> The Quincy puts you close to the everyday energy of UNC Charlotte, University Research Park, and the Blue Line, with I-85 and I-485 nearby for easy cross-city access. Start with coffee or errands around The Boardwalk at University City, stay for a lakefront bite, then trade the weekday pace for Mallard Creek Greenway time or a concert at Truliant Amphitheater.</p><p>Back home, townhome-style living gives the location room to breathe—attached garages, flex space, and community spaces made for work, workouts, and downtime. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Quincy connects polished rental living with Charlotte’s northside hub for transit, research, dining, and entertainment.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make your space work harder.</strong> At The Quincy, daily convenience starts at home with townhome-style layouts that pair <a href=\"/floor-plans\">flex space</a>, large closets, in-home washer and dryer, and a 2-car garage with polished finishes like quartz countertops, luxury flooring, efficient appliances, and an electronic thermostat.</p><p>When you step outside, your routine has room to shift from productive to relaxed. Knock out a focused session in the business pods, move at your pace in the fitness center with free weights, cool off by the pool, or meet up around the clubhouse, recreation room, BBQ area, and pickleball court. Explore the <a href=\"/gallery\">amenity gallery</a>, then see how these features come together in person with a <a href=\"/schedule-a-tour\">scheduled tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at The Quincy.</strong> Modern three- and four-bedroom townhomes pair upscale finishes, two-car garages, and smart-home technology with easy University City access. Explore available <a href=\"/floor-plans\">floor plans</a>, then apply online when you’re ready to make your move.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact The Quincy leasing team to learn more about modern three- and four-bedroom townhomes in University City, with upscale finishes, two-car garages, smart-home technology, and convenient access within the I-485 perimeter.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Quincy?</strong> Start here for quick answers about leasing, modern townhome living, <a href=\"/floor-plans\">floor plans</a>, <a href=\"/amenities\">amenities and finishes</a>, and community details in University City. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find a layout that gives every day more room to work.</strong> The Quincy’s three-bedroom townhome-style floor plan is designed with the space and polish you want in Charlotte: an open main living area, a convenient half bath, generous bedroom storage, and flex space you can shape around your routine.</p><p>Inside, quartz countertops, efficient appliances, luxury flooring, in-home washer and dryer, and an electronic thermostat keep the details streamlined. A <strong>2-car garage</strong> adds everyday ease, while the wider community brings more ways to unwind just beyond your door. Browse current pricing and availability below, compare the Fraser layout, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Quincy’s floor plan feels in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces before you step inside.</strong> Scroll through The Quincy’s photo gallery for a closer look at the details that shape each day: sunlit townhome-style rooms, polished kitchens with quartz countertops, luxury flooring underfoot, and storage that keeps the scene calm and uncluttered.</p><p>Beyond your front door, the images shift from quiet interiors to places made for downtime and momentum. Picture lounge-worthy pool views, a clubhouse setting, business pods framed for focus, and outdoor spaces ready for a grill night or a match on the pickleball court. Like what you see? Continue with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience The Quincy in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Quincy on the map.</strong> See available three- and four-bedroom townhomes in University City, then zoom out to discover nearby transit, major employers, recreation, and entertainment within the I-485 perimeter.</p>",
  "property_pets_blurb": "<p><strong>More room for the routines that come with pets.</strong> At The Quincy, pet-friendly townhome living in Charlotte feels practical from the moment you walk in: attached garages for easy load-in after a muddy walk, large closets for storing leashes and toys, in-home washer/dryer for quick cleanups, and luxury flooring that keeps everyday upkeep simple. Your pet policy details are listed below, including current limits and restrictions, so you can plan with confidence.</p><p>When it is time to stretch out, the community adds dog parks and open-air spots made for fresh-air breaks, with greenway options nearby in University City North. Browse the <a href=\"/amenities\">community amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Quincy fits your pet-friendly routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share The Quincy experience.</strong> Invite a friend to discover modern three- and four-bedroom townhomes with upscale finishes, two-car garages, smart-home technology, and resort-style spaces designed for comfort and connection—all with convenient access to University City, I-485, and the Blue Line Light Rail.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Quincy</strong><br>Log in to pay rent, submit maintenance requests, and manage your account from a community designed for modern comfort, connection, and everyday convenience in Charlotte’s University City.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, all in one place.</strong> Your search gets easier when you can see what residents have shared about life at The Quincy. Browse the ratings and reviews below for firsthand perspective on the spaces, service, and day-to-day experience in University City North. Use these insights alongside the rest of the site to compare what matters most to you and decide your next step with confidence.</p>",
  "property_created_at": "1786373927472",
  "property_scheduletour_blurb": "<p><strong>See The Quincy up close.</strong> Tour modern three- and four-bedroom townhomes with upscale finishes, two-car garages, and smart-home technology—then explore the resort-style spaces that bring everyday comfort and connection to University City. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>The Quincy leasing team will be in touch soon. In the meantime, look forward to modern three- and four-bedroom townhomes with upscale finishes, two-car garages, smart-home technology, and a University City location designed for easy access to work, recreation, and entertainment.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "© 2026 The Quincy. All Rights Reserved.",
  "property_seo_title_home": "The Quincy |  Apartments in Charlotte, NC",
  "property_seo_description_home": "Find your new home at The Quincy in Charlotte, NC! Enjoy spacious three-bedroom floor plans and luxury amenities like a pool, fitness center, and more.",
  "property_seo_title_floorplans": "Floor Plans | Charlotte, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect home at The Quincy in Charlotte, NC. Explore spacious three-bedroom floor plans designed for comfort and style. Start your journey today!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at The Quincy in Charlotte, NC! Enjoy luxury amenities like a pool, fitness center, and gourmet kitchens. Comfort meets convenience!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Step into luxury at The Quincy in Charlotte, NC! Spacious three-bedroom homes, top-notch amenities, and a vibrant community await you. Picture your new life!",
  "property_seo_title_virtualtours": "Virtual Tours | The Quincy Apartments",
  "property_seo_description_virtualtours": "Experience life at The Quincy in Charlotte, NC! Take a virtual tour of our spacious three-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Quincy Apartments",
  "property_seo_description_interactivemap": "Find your ideal 3-bedroom apartment at The Quincy in Charlotte, NC! Check out our interactive map for pricing, amenities, and a vibrant community experience.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Discover Charlotte's charm at The Quincy! Enjoy local hotspots and rich culture just steps from your spacious three-bedroom apartment.",
  "property_seo_title_contact": "Contact Us | The Quincy",
  "property_seo_description_contact": "Connect with The Quincy in Charlotte, NC! Check out our spacious three-bedroom floor plans and reach out to our leasing team with any questions you have!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Find answers to your questions about The Quincy in Charlotte, NC. Explore our amenities, floor plans, and what makes our community a perfect fit for you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover life at The Quincy in Charlotte, NC! Enjoy spacious three-bedroom homes and luxury amenities like a pool and fitness center!",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Experience luxury living at The Quincy in Charlotte, NC! Enjoy spacious three-bedroom apartments with premium amenities. Secure your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | The Quincy",
  "property_seo_description_residentaccess": "Enjoy convenience at The Quincy in Charlotte! Log in to your resident portal for easy rent payments, maintenance requests, and community connection.",
  "property_seo_title_referafriend": "Refer A Friend | The Quincy",
  "property_seo_description_referafriend": "Refer a friend to The Quincy in Charlotte, NC! Great connections make exceptional neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Quincy",
  "property_seo_description_scheduletour": "Experience modern living at The Quincy in Charlotte, NC. Schedule your personalized tour today and envision your new home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | The Quincy",
  "property_seo_description_privacy": "At The Quincy in Charlotte, NC, we value your privacy. Learn how we protect your information and ensure a secure living experience. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Quincy",
  "property_seo_description_accessibility": "At The Quincy in Charlotte, NC, we prioritize digital inclusion. Our accessibility statement ensures everyone can enjoy our vibrant community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Quincy",
  "property_seo_description_sitemap": "Unlock your ideal living at The Quincy in Charlotte, NC! Navigate our sitemap for a seamless look at your future home and all we offer.",
  "property_seo_title_thankyou": "Thank You | The Quincy",
  "property_seo_description_thankyou": "Thank you for reaching out to The Quincy! Our team will connect soon to help you find your perfect home in vibrant Charlotte, NC. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Charlotte, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793288614017",
  "amenities": [
    {
      "id": "ec_da0aa64d1aa710543edc622d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250740",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dcd564169d2f3d96685103a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250738",
      "title": "Recreation Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9085f6f9497c87323c415812",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250737",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4844df0422fc7217481b35eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250735",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a740249daf960f85e2d838d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250730",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f992b0c38ead0d12e36813a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250725",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ca44d24abad149c33de4a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250724",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f65210992527cf126ee403bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250731",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d88fcf1fa3131d983863132b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874792",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79d07dc69a2e36ef0c12eda8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874791",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e4efcce94645d4be495de94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874788",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73cfdca9b6c3e9e97bfd80df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874787",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1510a96d961512b211c4b1dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874786",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8f30399f34c7d15087aa7f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874784",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df4147fa38710025e138ff3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874783",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e95731438cedce757b43be92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874782",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bc65708c02da03cc61c8e69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250726",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "Pickleball Court",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c20485d0892d5513528f0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "128250736",
      "title": "Business Pods",
      "amount": "false",
      "description": "Business Pods",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74772840e153e76639000bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874801",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac410fc90e5ce0be84b0374d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874804",
      "title": "2-car Garage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f8bbf1eadaa67678f4dd32d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874805",
      "title": "Flex Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_812da163561ea8bf4a230533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "127874807",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_962edaf1780b26ad053ddc07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "title": "Lifestyle",
      "description": "Welcome home to The Quincy! A happy family arrives with boxes and plants, ready to start their new life in our vibrant community.",
      "link": "false",
      "alt_text": "A man is holding a box and a woman is standing behind him with a child.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/The%20Quincy%20Portal%20Banner%20(1920%20x%20450%20px).png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_77e5b106-d039-43d2-a1c5-467bcd50aa33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Giacomo's Pizzeria & Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10230 Berkeley Pl Dr Ste 160, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual, family-owned restaurant serving pizza, subs, pasta & other familiar Italian dishes.",
      "poi_long_description": "Casual, family-owned restaurant serving pizza, subs, pasta & other familiar Italian dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec32-fd91-7728-8495-762ec3bc9461.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-fd91-7728-8495-762ec3bc9461",
        "storage_key": "property/6767906449167640/019fec32-fd91-7728-8495-762ec3bc9461.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.giacomospizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=159206261602034233",
      "poi_item_slug": "giacomos-pizzeria--italian-restaurant",
      "poi_latitude": "35.327191",
      "poi_longitude": "-80.738636",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-971-7313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAzhbJWkcVIgROaLOXECdNQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6973620d-27fc-4be5-8308-0d80e163e90a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Topgolf Charlotte - University",
      "poi_type": "Entertainment",
      "poi_address": "9110 Drivers Wy, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2e-fe73-776e-8c7b-bb8375031766.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-fe73-776e-8c7b-bb8375031766",
        "storage_key": "property/6767906449167640/019fec2e-fe73-776e-8c7b-bb8375031766.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://topgolf.com/us/charlotte-university/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14916876276335703365",
      "poi_item_slug": "topgolf-charlotte---university",
      "poi_latitude": "35.2875467",
      "poi_longitude": "-80.7702764",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-701-0450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWWWOZUfVIgRRfVwufBjA88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_52bdfc74-e1fb-4fa6-aa4d-c32da2b305d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Blaze Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8948 J M Keynes Dr #400, Charlotte, NC 28262, USA",
      "poi_short_description": "Hip counter-serve pizzeria dishing up crispy, thin-crust pies made with creative toppings & sauces.",
      "poi_long_description": "Hip counter-serve pizzeria dishing up crispy, thin-crust pies made with creative toppings & sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec32-ff60-710f-ae5b-8d1e55c2abfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-ff60-710f-ae5b-8d1e55c2abfc",
        "storage_key": "property/6767906449167640/019fec32-ff60-710f-ae5b-8d1e55c2abfc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.blazepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17455837503924574762",
      "poi_item_slug": "blaze-pizza",
      "poi_latitude": "35.3105691",
      "poi_longitude": "-80.7469788",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-217-4306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZsy2jwcVIgRKppdjrmXP_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_9fd8b3db-0ebd-42de-957b-be9b7f4b820b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Boardwalk Billy's Raw Bar and Ribs",
      "poi_type": "Restaurants",
      "poi_address": "9005 J M Keynes Dr #2, Charlotte, NC 28262, USA",
      "poi_short_description": "Festive, easygoing hangout featuring BBQ, seafood & drinks plus a covered patio & a lively bar.",
      "poi_long_description": "Festive, easygoing hangout featuring BBQ, seafood & drinks plus a covered patio & a lively bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2e-fd52-72cd-ab4c-66aafa2cce7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-fd52-72cd-ab4c-66aafa2cce7d",
        "storage_key": "property/6767906449167640/019fec2e-fd52-72cd-ab4c-66aafa2cce7d.webp",
        "width": 1280,
        "height": 573
      },
      "poi_business_url": "https://university.boardwalkbillys.com/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=9333202762111351091",
      "poi_item_slug": "boardwalk-billys-raw-bar-and-ribs",
      "poi_latitude": "35.3106616",
      "poi_longitude": "-80.7495888",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-503-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7a5WzscVIgRM3lXdHYyhoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_42460f49-593a-482b-a84a-f83ab4593c11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "City Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "8948 J M Keynes Dr #420, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-serve smokehouse chain offering classic barbecue fare in down-home settings.",
      "poi_long_description": "Counter-serve smokehouse chain offering classic barbecue fare in down-home settings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec32-ff19-7347-be8a-d1245fb567f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-ff19-7347-be8a-d1245fb567f1",
        "storage_key": "property/6767906449167640/019fec32-ff19-7347-be8a-d1245fb567f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.citybbq.com/?utm_campaign=GMB&utm_medium=GBM&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3573752813142911568",
      "poi_item_slug": "city-barbeque",
      "poi_latitude": "35.3103598",
      "poi_longitude": "-80.7468131",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-278-8015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTpGvjwcVIgRUKpvvj-FmDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_ba08f165-03e7-4112-827c-bd9c4d6f0ade",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Famous Toastery",
      "poi_type": "Restaurants",
      "poi_address": "8933 J M Keynes Dr #2, Charlotte, NC 28262, USA",
      "poi_short_description": "Comfortable setting for classic & creative takes on American breakfast, brunch & lunch dishes.",
      "poi_long_description": "Comfortable setting for classic & creative takes on American breakfast, brunch & lunch dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-03bb-71ce-8e9f-fed05d472fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-03bb-71ce-8e9f-fed05d472fdf",
        "storage_key": "property/6767906449167640/019fec33-03bb-71ce-8e9f-fed05d472fdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famoustoastery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=615834463933113794",
      "poi_item_slug": "famous-toastery",
      "poi_latitude": "35.3103407",
      "poi_longitude": "-80.7494772",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-503-9599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB74QVzscVIgRwiUtny7iiwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_fd122baa-4018-41a8-b370-eea4eddf946d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Ishi",
      "poi_type": "Restaurants",
      "poi_address": "8205 University City Blvd #8129, Charlotte, NC 28213, USA",
      "poi_short_description": "Stalwart restaurant offering a variety of sushi rolls & Japanese hibachi meals in a relaxed setting.",
      "poi_long_description": "Stalwart restaurant offering a variety of sushi rolls & Japanese hibachi meals in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-2441-70fa-9c22-14e5f720f123.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-2441-70fa-9c22-14e5f720f123",
        "storage_key": "property/6767906449167640/019fec33-2441-70fa-9c22-14e5f720f123.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sushiishi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5691385082080949325",
      "poi_item_slug": "ishi",
      "poi_latitude": "35.294927",
      "poi_longitude": "-80.7474965",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-921-9219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwphFlgqw4ARTXRk8ZPc-04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_c584f41b-39ff-4d1d-92ec-8c6d92716632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Sabor Latin Street Grill",
      "poi_type": "Restaurants",
      "poi_address": "9325 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Tacos, quesadillas, and other Latin street food served in a counter-serve environment with daily specials.",
      "poi_long_description": "Tacos, quesadillas, and other Latin street food served in a counter-serve environment with daily specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-0745-70d9-9893-e154829d0d00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-0745-70d9-9893-e154829d0d00",
        "storage_key": "property/6767906449167640/019fec33-0745-70d9-9893-e154829d0d00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saborlatingrill.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-website-university",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606994444976766843",
      "poi_item_slug": "sabor-latin-street-grill",
      "poi_latitude": "35.3107152",
      "poi_longitude": "-80.7460624",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-819-7274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2eKxFIdVIgRe78pKqcK9a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "custom_232060d8-4f9d-4054-842d-c256f9f674a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Sol' Delish",
      "poi_type": "Restaurants",
      "poi_address": "8927 J M Keynes Dr #100, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual restaurant featuring Southern eats, including fried chicken and seafood, as well as cocktails and wine.",
      "poi_long_description": "Casual restaurant featuring Southern eats, including fried chicken and seafood, as well as cocktails and wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-08d0-77fe-ad06-8672d1eb1f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-08d0-77fe-ad06-8672d1eb1f3c",
        "storage_key": "property/6767906449167640/019fec33-08d0-77fe-ad06-8672d1eb1f3c.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://soldelish.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14251820301083844194",
      "poi_item_slug": "sol-delish",
      "poi_latitude": "35.3092257",
      "poi_longitude": "-80.7492875",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-733-9430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSB6D-UdVIgRYp7N8A2jyMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "custom_1afc9f93-59f8-474f-a5be-45e4a57e6ee4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Zapata's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8927 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Family-family outpost serving generous portions of familiar Mexican plates in relaxed surrounds.",
      "poi_long_description": "Family-family outpost serving generous portions of familiar Mexican plates in relaxed surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-0fd9-7599-a2f6-58473de3c66d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-0fd9-7599-a2f6-58473de3c66d",
        "storage_key": "property/6767906449167640/019fec33-0fd9-7599-a2f6-58473de3c66d.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "https://zapatasuniversity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9505794243155199311",
      "poi_item_slug": "zapatas-mexican-restaurant",
      "poi_latitude": "35.3090293",
      "poi_longitude": "-80.7492867",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-503-1979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJucmkqSQcVIgRTwU4E4Bd64M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_40fc07bd-0dfa-40f9-9ba9-2388dc6debfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "8936 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-16f0-717a-b10d-78d5b534f8b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-16f0-717a-b10d-78d5b534f8b3",
        "storage_key": "property/6767906449167640/019fec33-16f0-717a-b10d-78d5b534f8b3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://cava.com/locations/university-place-nc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16556343140839884598",
      "poi_item_slug": "cava",
      "poi_latitude": "35.3099239",
      "poi_longitude": "-80.74786139999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-243-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db2-7258-a446-be9f5114f9bb",
        "storage_key": "property/6767906449167640/019fec2f-2db2-7258-a446-be9f5114f9bb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7psTCMcVIgRNoc8CV7yw-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_3a2df9ef-9285-4bf7-812b-035aea9e0069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2720 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-1246-71bb-a1fa-b23b96f148a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-1246-71bb-a1fa-b23b96f148a7",
        "storage_key": "property/6767906449167640/019fec33-1246-71bb-a1fa-b23b96f148a7.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/nc/charlotte/cochran-commons/097/00220?cid=loc_09700220_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2901704986130686064",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "35.3415072",
      "poi_longitude": "-80.7648766",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-717-7501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2da5-721e-b675-9816fc216c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2da5-721e-b675-9816fc216c89",
        "storage_key": "property/6767906449167640/019fec2f-2da5-721e-b675-9816fc216c89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SchLFUcVIgRcKBMnU_tRCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c299e1e4-40c2-4c3c-af4a-5a9c94a9b97e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "9323 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocer with a specialty pastry section selling cookies, and beer and wine.",
      "poi_long_description": "Grocer with a specialty pastry section selling cookies, and beer and wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-1cbd-7322-9d69-e559d268a95b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-1cbd-7322-9d69-e559d268a95b",
        "storage_key": "property/6767906449167640/019fec33-1cbd-7322-9d69-e559d268a95b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/nc/charlotte/9323-n-tryon-st?y_source=1_NTA0NjkwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14276779664295595948",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.3140856",
      "poi_longitude": "-80.7444611",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-547-0248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2da5-721e-b675-9816fc216c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2da5-721e-b675-9816fc216c89",
        "storage_key": "property/6767906449167640/019fec2f-2da5-721e-b675-9816fc216c89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYe47j0cVIgRrA_cinZPIcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e09b395d-d2cb-4854-bdd8-314363ac3411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9609 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-1c0a-7716-a256-3da4c330ab95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-1c0a-7716-a256-3da4c330ab95",
        "storage_key": "property/6767906449167640/019fec33-1c0a-7716-a256-3da4c330ab95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/charlotte/9609-n-tryon-street/fe86",
      "poi_directions_map_url": "https://maps.google.com/?cid=16361415549057010490",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.317152",
      "poi_longitude": "-80.738959",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2da5-721e-b675-9816fc216c89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2da5-721e-b675-9816fc216c89",
        "storage_key": "property/6767906449167640/019fec2f-2da5-721e-b675-9816fc216c89.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx3n-BAAdVIgROosYYMFsD-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_37423d6b-82e8-4cc8-8a7b-ec83c7793fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7735 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_long_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-19f9-73a1-92f6-aced4dea70e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-19f9-73a1-92f6-aced4dea70e1",
        "storage_key": "property/6767906449167640/019fec33-19f9-73a1-92f6-aced4dea70e1.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2134-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7693588847703310125",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2951583",
      "poi_longitude": "-80.7581024",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-547-0525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d81-7093-b9c7-796205f93dd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d81-7093-b9c7-796205f93dd6",
        "storage_key": "property/6767906449167640/019fec2f-2d81-7093-b9c7-796205f93dd6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9wzzDDAcVIgRLT9Da0sexWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d955cdc4-c881-4c3c-94fb-ecfe411e2c00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8538 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-30af-767e-b28f-3bedd13f65fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-30af-767e-b28f-3bedd13f65fc",
        "storage_key": "property/6767906449167640/019fec33-30af-767e-b28f-3bedd13f65fc.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8538+n+tryon+st-charlotte-nc-28262/id=4547",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712234873269453930",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.30457740000001",
      "poi_longitude": "-80.7496324",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-547-8551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7dKASQcVIgRagRj3CjKyIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_b7cdde8f-bb14-44a1-8478-a57a9143dfa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "The Shoppes at University Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "8931 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Shopping center with restaurants and stores, plus a boardwalk with paddleboats.",
      "poi_long_description": "Shopping center with restaurants and stores, plus a boardwalk with paddleboats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-2818-7191-b547-14e112f21e31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-2818-7191-b547-14e112f21e31",
        "storage_key": "property/6767906449167640/019fec33-2818-7191-b547-14e112f21e31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shoppesatuniversityplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14212933022838765680",
      "poi_item_slug": "the-shoppes-at-university-place",
      "poi_latitude": "35.309802",
      "poi_longitude": "-80.748663",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d81-7093-b9c7-796205f93dd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d81-7093-b9c7-796205f93dd6",
        "storage_key": "property/6767906449167640/019fec2f-2d81-7093-b9c7-796205f93dd6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Wp0EEIdVIgRcDi56kd7PsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_62354288-2a35-4874-8a46-7bc2347208c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "University Meadows Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Public elementary school on Pavilion Boulevard, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public elementary school on Pavilion Boulevard, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-2b44-73df-93ad-7c1109e02863.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-2b44-73df-93ad-7c1109e02863",
        "storage_key": "property/6767906449167640/019fec33-2b44-73df-93ad-7c1109e02863.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://universitymeadowses.cmsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4346912931435958724",
      "poi_item_slug": "university-meadows-elementary-school",
      "poi_latitude": "35.315458",
      "poi_longitude": "-80.71452599999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-343-3685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db3-740c-9b0c-181fdefbbd57",
        "storage_key": "property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz26ydPMbVIgRxNHKu0dWUzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_695220a4-f9d2-49aa-9a61-d92eb2b1fb6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "James Martin Middle School",
      "poi_type": "Education",
      "poi_address": "6301 University Pointe Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Public middle school on University Pointe Boulevard, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public middle school on University Pointe Boulevard, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-30a6-7391-baf3-eec021bd5e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-30a6-7391-baf3-eec021bd5e8a",
        "storage_key": "property/6767906449167640/019fec33-30a6-7391-baf3-eec021bd5e8a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/jamesmartinMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5618926938611783760",
      "poi_item_slug": "james-martin-middle-school",
      "poi_latitude": "35.2994377",
      "poi_longitude": "-80.7661055",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-343-5382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db3-740c-9b0c-181fdefbbd57",
        "storage_key": "property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsavmwH8eVIgRUBjUwkdw-k0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d49b4127-339f-4fdb-bd75-d558a183dc78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Julius L. Chambers High School",
      "poi_type": "Education",
      "poi_address": "7600 IBM Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Public high school on IBM Drive, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public high school on IBM Drive, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-2cbe-710e-95ce-85530934a41a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-2cbe-710e-95ce-85530934a41a",
        "storage_key": "property/6767906449167640/019fec33-2cbe-710e-95ce-85530934a41a.webp",
        "width": 413,
        "height": 275
      },
      "poi_business_url": "https://www.cmsk12.org/chambersHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17524243692802135939",
      "poi_item_slug": "julius-l-chambers-high-school",
      "poi_latitude": "35.3008041",
      "poi_longitude": "-80.76758769999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-343-5284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db3-740c-9b0c-181fdefbbd57",
        "storage_key": "property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSZQhk8mVIgRg9fZisqeMvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_14ab0061-1267-4d3d-a102-532b5bae16ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "UNC Charlotte's main campus on University City Boulevard, the largest university in the Charlotte region.",
      "poi_long_description": "UNC Charlotte's main campus on University City Boulevard, the largest university in the Charlotte region.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-03f6-73e7-892b-bfae7de1b847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-03f6-73e7-892b-bfae7de1b847",
        "storage_key": "property/6767906449167640/019fec2f-03f6-73e7-892b-bfae7de1b847.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db3-740c-9b0c-181fdefbbd57",
        "storage_key": "property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4d45d1ee-f84c-447d-aa2a-c7686654e2e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "University Child Development Center",
      "poi_type": "Education",
      "poi_address": "8303 University Executive Park Dr Ste 450, Charlotte, NC 28262, USA",
      "poi_short_description": "Daycare center located in the University Executive Park offering a pre-K program.",
      "poi_long_description": "Daycare center located in the University Executive Park offering a pre-K program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-367d-704f-81ae-89a42ac8e110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-367d-704f-81ae-89a42ac8e110",
        "storage_key": "property/6767906449167640/019fec33-367d-704f-81ae-89a42ac8e110.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://universitycdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3043994702130764041",
      "poi_item_slug": "university-child-development-center",
      "poi_latitude": "35.3023501",
      "poi_longitude": "-80.7556594",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-549-4029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db3-740c-9b0c-181fdefbbd57",
        "storage_key": "property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSy3gdigcVIgRCdmsxg1xPio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_27f620ac-f2e6-47d4-a29c-e6a27c152d5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-37a4-728a-9d35-c3f55faa0a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-37a4-728a-9d35-c3f55faa0a83",
        "storage_key": "property/6767906449167640/019fec33-37a4-728a-9d35-c3f55faa0a83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3273693",
      "poi_longitude": "-80.71079309999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_3d952590-e8d9-420a-bd6c-ed79f24416bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-1a9a-76fd-9f72-f72a12311d59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-1a9a-76fd-9f72-f72a12311d59",
        "storage_key": "property/6767906449167640/019fec2f-1a9a-76fd-9f72-f72a12311d59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_dcbbe333-7572-4113-a243-e2641fe12537",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Halton Arena",
      "poi_type": "Entertainment",
      "poi_address": "9201 University City Blvd #202, Charlotte, NC 28223, USA",
      "poi_short_description": "Basketball venue, also used for graduations and cheerleading competitions. Friendly staff.",
      "poi_long_description": "Basketball venue, also used for graduations and cheerleading competitions. Friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-0716-732b-ae11-58099ec4a307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-0716-732b-ae11-58099ec4a307",
        "storage_key": "property/6767906449167640/019fec2f-0716-732b-ae11-58099ec4a307.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://haltonarena.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6402797709796031827",
      "poi_item_slug": "halton-arena",
      "poi_latitude": "35.306403",
      "poi_longitude": "-80.7344525",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-687-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8WoA4QQcVIgRU70T9ZdO21g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_305e9f28-07da-4681-a7f9-58dc288b7e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Discovery Place Science",
      "poi_type": "Entertainment",
      "poi_address": "168 W 6th St, Charlotte, NC 28202, USA",
      "poi_short_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_long_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-3698-712e-97ac-adb8118027ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-3698-712e-97ac-adb8118027ec",
        "storage_key": "property/6767906449167640/019fec33-3698-712e-97ac-adb8118027ec.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://discoveryplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672994214166199027",
      "poi_item_slug": "discovery-place-science",
      "poi_latitude": "35.229441",
      "poi_longitude": "-80.8409271",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-327-2189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-6ccc-7543-bb92-104e7802112c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-6ccc-7543-bb92-104e7802112c",
        "storage_key": "property/6767906449167640/019fec33-6ccc-7543-bb92-104e7802112c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-LB1SSgVogR8_pkSkmqXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_967c2ad4-84ac-453e-8e5b-c3fe449ba7eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Spectrum Center",
      "poi_type": "Entertainment",
      "poi_address": "333 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "Concert venue & home of the NBA's Bobcats & the AHL's Checkers, with art exhibits & food galleries.",
      "poi_long_description": "Concert venue & home of the NBA's Bobcats & the AHL's Checkers, with art exhibits & food galleries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-49b2-7161-87f0-f326e007856f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-49b2-7161-87f0-f326e007856f",
        "storage_key": "property/6767906449167640/019fec33-49b2-7161-87f0-f326e007856f.webp",
        "width": 1280,
        "height": 897
      },
      "poi_business_url": "http://www.spectrumcentercharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8512660423163068154",
      "poi_item_slug": "spectrum-center",
      "poi_latitude": "35.2251952",
      "poi_longitude": "-80.8393468",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-688-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRX2cPiSgVogR-j4piI0LI3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_02b09eb7-18cd-4ca5-a814-1c11ab4addc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Atrium Health University City",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Full-service Atrium Health hospital on North Tryon Street, the University City area's community hospital.",
      "poi_long_description": "Full-service Atrium Health hospital on North Tryon Street, the University City area's community hospital.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-1143-70e8-a80e-505d64bb40f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-1143-70e8-a80e-505d64bb40f4",
        "storage_key": "property/6767906449167640/019fec2f-1143-70e8-a80e-505d64bb40f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db0-72ea-aec3-ae00f423e851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db0-72ea-aec3-ae00f423e851",
        "storage_key": "property/6767906449167640/019fec2f-2db0-72ea-aec3-ae00f423e851.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a868177e-e650-4e4b-9883-6e12a6931c62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9325 JW Clay Blvd Ste 221, Charlotte, NC 28262, USA",
      "poi_short_description": "Atrium Health walk-in urgent care in University City, on JW Clay Boulevard.",
      "poi_long_description": "Atrium Health walk-in urgent care in University City, on JW Clay Boulevard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-4d3b-7560-b30a-0238d0cdb386.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-4d3b-7560-b30a-0238d0cdb386",
        "storage_key": "property/6767906449167640/019fec33-4d3b-7560-b30a-0238d0cdb386.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5661548961259477027",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3107795",
      "poi_longitude": "-80.7457122",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-863-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUFVFxgdVIgRI1hausjckU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_897e50b0-e6d4-4cc0-aa22-b7987ce87411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "FastMed Urgent Care Charlotte Mallard Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "2728 W Mallard Creek Church Rd Ste 300, Charlotte, NC 28262, USA",
      "poi_short_description": "Walk-in urgent care clinic on West Mallard Creek Church Road.",
      "poi_long_description": "Walk-in urgent care clinic on West Mallard Creek Church Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-47ab-7701-9630-3748b16c352f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-47ab-7701-9630-3748b16c352f",
        "storage_key": "property/6767906449167640/019fec33-47ab-7701-9630-3748b16c352f.webp",
        "width": 904,
        "height": 609
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/charlotte-nc-walk-in-clinic-west-mallard-creek-church-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=12204928611885799257",
      "poi_item_slug": "fastmed-urgent-care-charlotte-mallard-creek",
      "poi_latitude": "35.3417425",
      "poi_longitude": "-80.7655249",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-218-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhe1vMVUcVIgRWVd0dOidYKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c101466e-bdb9-490b-b0d6-3afabc859eb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Keith Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8100 Old Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Offering programs and services for all ages and abilities, this youth center has a pool, and gym.",
      "poi_long_description": "Offering programs and services for all ages and abilities, this youth center has a pool, and gym.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-0e66-77dc-b488-4f4f32948be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-0e66-77dc-b488-4f4f32948be3",
        "storage_key": "property/6767906449167640/019fec2f-0e66-77dc-b488-4f4f32948be3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ymcacharlotte.org/locations/keith-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=9660733629701512364",
      "poi_item_slug": "keith-family-ymca",
      "poi_latitude": "35.3160647",
      "poi_longitude": "-80.77850409999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-716-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_l4NMQdVIgRrFwHLA3SEYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_376d296a-ba80-44fd-88cc-3d1d02c6b53e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3024 Prosperity Church Rd A, Charlotte, NC 28269, USA",
      "poi_short_description": "Spacious health club chain providing classes, free weights, cardio equipment, and a personal trainer.",
      "poi_long_description": "Spacious health club chain providing classes, free weights, cardio equipment, and a personal trainer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-0d4e-7062-a576-5d96f0c4b7e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-0d4e-7062-a576-5d96f0c4b7e3",
        "storage_key": "property/6767906449167640/019fec2f-0d4e-7062-a576-5d96f0c4b7e3.webp",
        "width": 408,
        "height": 306
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1314&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5303975230379288128",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "35.34348",
      "poi_longitude": "-80.76956",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-270-8616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d82-71ec-affa-010b7fad200f",
        "storage_key": "property/6767906449167640/019fec2f-2d82-71ec-affa-010b7fad200f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0K3YZ8dVIgRQGY60F6Bm0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2d7af6cb-eb3c-49a3-ae26-29899c2fde00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Cochran Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700-2800 W Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Shopping center featuring Harris Teeter groceries, eateries, and personal services.",
      "poi_long_description": "Shopping center featuring Harris Teeter groceries, eateries, and personal services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-4da4-771e-8484-e879dcb83b5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-4da4-771e-8484-e879dcb83b5b",
        "storage_key": "property/6767906449167640/019fec33-4da4-771e-8484-e879dcb83b5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regencycenters.com/property/detail/60314/Cochran-Commons",
      "poi_directions_map_url": "https://maps.google.com/?cid=12131066941942868027",
      "poi_item_slug": "cochran-commons",
      "poi_latitude": "35.3411944",
      "poi_longitude": "-80.76537139999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-831-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2d81-7093-b9c7-796205f93dd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2d81-7093-b9c7-796205f93dd6",
        "storage_key": "property/6767906449167640/019fec2f-2d81-7093-b9c7-796205f93dd6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJkx1VK1UcVIgROyj9TBw1Wqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1aa1b8cf-ac80-4684-b1d1-86f8339024cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Mallard Creek Greenway - East Terminus",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Eastern trailhead of the Mecklenburg County Mallard Creek Greenway, a paved creekside trail for walking and cycling.",
      "poi_long_description": "Eastern trailhead of the Mecklenburg County Mallard Creek Greenway, a paved creekside trail for walking and cycling.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-51e7-76a0-8ef0-103b1522b3fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-51e7-76a0-8ef0-103b1522b3fb",
        "storage_key": "property/6767906449167640/019fec33-51e7-76a0-8ef0-103b1522b3fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Greenways/OpenGreenways/Pages/MallardCreekandClark'sCreek.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15209037215157520469",
      "poi_item_slug": "mallard-creek-greenway---east-terminus",
      "poi_latitude": "35.32064940000001",
      "poi_longitude": "-80.73165089999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-6ccd-7360-a569-0f44b438e562.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-6ccd-7360-a569-0f44b438e562",
        "storage_key": "property/6767906449167640/019fec33-6ccd-7360-a569-0f44b438e562.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaiP2cwdVIgRVQgpKcRaEdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_3848d14a-d87e-4b31-a15c-ee8f9711c51e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Clarks Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9729 Mallard Creek Rd, Charlotte, NC 28267, USA",
      "poi_short_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_long_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-516e-74b4-beab-b57a7e7cdcdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-516e-74b4-beab-b57a7e7cdcdf",
        "storage_key": "property/6767906449167640/019fec33-516e-74b4-beab-b57a7e7cdcdf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285017145315421591",
      "poi_item_slug": "clarks-creek-greenway",
      "poi_latitude": "35.3345362",
      "poi_longitude": "-80.7740029",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-6ccd-7360-a569-0f44b438e562.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-6ccd-7360-a569-0f44b438e562",
        "storage_key": "property/6767906449167640/019fec33-6ccd-7360-a569-0f44b438e562.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWo_U0gcVIgRl-3jjGiTPsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_20055b84-421a-4152-aa60-c3e20bb7e7ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Kirk Farm Fields Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "210 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Trail-lined park featuring woods and an open field, plus soccer nets.",
      "poi_long_description": "Trail-lined park featuring woods and an open field, plus soccer nets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-5114-767d-b7fc-bca3d6c7e5d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-5114-767d-b7fc-bca3d6c7e5d7",
        "storage_key": "property/6767906449167640/019fec33-5114-767d-b7fc-bca3d6c7e5d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Parks/ParksByRegion/NorthRegion/Pages/KirkFarmFields.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3813087192918391643",
      "poi_item_slug": "kirk-farm-fields-park",
      "poi_latitude": "35.3221854",
      "poi_longitude": "-80.7308485",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2da8-75e4-8f3f-c6501975229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2da8-75e4-8f3f-c6501975229a",
        "storage_key": "property/6767906449167640/019fec2f-2da8-75e4-8f3f-c6501975229a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7azmx3IcVIgRW_t9b5nO6jQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_678a15ff-1e82-4686-a3cc-2057e60bf256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Mallard Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3001 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation area featuring 8 soccer fields, a batting cage, and 2 playgrounds, plus a volleyball court.",
      "poi_long_description": "Recreation area featuring 8 soccer fields, a batting cage, and 2 playgrounds, plus a volleyball court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-57d1-7599-b2f1-5cdf4fcd196b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-57d1-7599-b2f1-5cdf4fcd196b",
        "storage_key": "property/6767906449167640/019fec33-57d1-7599-b2f1-5cdf4fcd196b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=412983690555762575",
      "poi_item_slug": "mallard-creek-park",
      "poi_latitude": "35.3614698",
      "poi_longitude": "-80.7624001",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2da8-75e4-8f3f-c6501975229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2da8-75e4-8f3f-c6501975229a",
        "storage_key": "property/6767906449167640/019fec2f-2da8-75e4-8f3f-c6501975229a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6J0seEcVIgRjyebfXo2uwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c9232985-456c-46ed-952c-af9acfb73c58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Mallard Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "9801 Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Public elementary school on Mallard Creek Road, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public elementary school on Mallard Creek Road, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-57b8-7402-b1b0-22b17c8254cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-57b8-7402-b1b0-22b17c8254cd",
        "storage_key": "property/6767906449167640/019fec33-57b8-7402-b1b0-22b17c8254cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mallardcreekes.cmsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9511436041936188988",
      "poi_item_slug": "mallard-creek-elementary-school",
      "poi_latitude": "35.3354412",
      "poi_longitude": "-80.7741362",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-343-3980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2db3-740c-9b0c-181fdefbbd57",
        "storage_key": "property/6767906449167640/019fec2f-2db3-740c-9b0c-181fdefbbd57.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV3xM6uscVIgRPDZ0t69o_4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d9f2cce2-295e-4a17-a134-60c82081ba80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Reedy Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Rocky River Rd, Charlotte, NC 28215, USA",
      "poi_short_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_long_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-1587-756e-9a9a-951899cd4bb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-1587-756e-9a9a-951899cd4bb1",
        "storage_key": "property/6767906449167640/019fec2f-1587-756e-9a9a-951899cd4bb1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4056376883772919066",
      "poi_item_slug": "reedy-creek-nature-preserve",
      "poi_latitude": "35.26378750000001",
      "poi_longitude": "-80.71209840000002",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2da8-75e4-8f3f-c6501975229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2da8-75e4-8f3f-c6501975229a",
        "storage_key": "property/6767906449167640/019fec2f-2da8-75e4-8f3f-c6501975229a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYzQOkoZVIgRGg1kwEglSzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_99be9844-13bb-4f09-8153-94f93bdf507a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "custom",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec33-63e8-725a-9c98-d7db5f1bce92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-63e8-725a-9c98-d7db5f1bce92",
        "storage_key": "property/6767906449167640/019fec33-63e8-725a-9c98-d7db5f1bce92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "19.7 mi",
      "poi_walking_minutes": "7 hours 18 mins",
      "poi_biking_minutes": "1 hour 59 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167640/019fec2f-2ff1-76d4-9516-0817942ab1d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-2ff1-76d4-9516-0817942ab1d6",
        "storage_key": "property/6767906449167640/019fec2f-2ff1-76d4-9516-0817942ab1d6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bbc5afe46e158c7a1d0bdbbc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_39dae3e1c7195adc9b68dff4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5292d74ba687433c5bc6af78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e7e02d3b5866d8afe6ced196",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_dd0cb59e864805699114b2d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_3408dd59781e0726d3e4ebc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "yardi",
      "external_id": "2836834",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "No breed restrictions"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-a4f3-7259-bb3e-94dc9dae34b1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Quincy Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640"
    },
    {
      "lead_collector_id": "01a0abe0-a567-74c0-8675-8a21d70de982",
      "lead_source": "LANDING_PAGE",
      "name": "The Quincy Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-charlotte-nc",
      "search_query": "luxury apartments with in-unit laundry Charlotte NC",
      "category": "Amenity",
      "h1_title": "Luxury Apts with In-Unit Laundry in Charlotte",
      "h2_subtitle": "Discover luxury apartments with in-unit laundry at The Quincy. Enjoy high-end living in Charlotte's University City North neighborhood.",
      "page_copy": "Welcome to The Quincy, where luxury living meets convenience in Charlotte, NC. Tucked away in the University City North neighborhood, our apartments offer the perfect blend of style and function. Each unit boasts in-unit laundry, allowing you to enjoy the ultimate convenience of doing laundry right at home. Our residences are designed with efficient appliances and luxury flooring, creating an elegant atmosphere.\n\nThe Quincy is not just about the interiors; it offers a variety of amenities such as business pods and a BBQ/picnic area to enhance your lifestyle. Plus, benefit from a 2-car garage for ample storage and parking. Living at The Quincy means having everything you need in a luxury apartment with in-unit laundry, making life in Charlotte more comfortable and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry in Charlotte NC",
      "seo_description": "Experience luxury apartments with in-unit laundry at The Quincy, Charlotte NC. Enjoy efficient living and high-end amenities in University City North.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-university-city-north",
      "search_query": "air conditioned apartments in University City North",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in University City",
      "h2_subtitle": "Stay cool in air conditioned apartments at The Quincy. Enjoy modern living at its finest in Charlotte's University City North neighborhood.",
      "page_copy": "Experience comfort at its best at The Quincy, located in the vibrant University City North neighborhood of Charlotte, NC. Our air conditioned apartments are designed to provide you with a cool oasis, ensuring comfort during the warmest months. With thoughtfully designed interiors, including efficient appliances and luxury flooring, you'll find relaxation and style in every corner.\n\nBeyond the cool interiors, The Quincy offers a range of community amenities like business pods and a BBQ/picnic area, perfect for socializing and unwinding. Our 2-car garage provides ease of access and ample storage. Choose The Quincy for air conditioned living where convenience and luxury meet in University City North, Charlotte.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in University City North",
      "seo_description": "Find comfort at The Quincy with air conditioned apartments in University City North, Charlotte. Enjoy stylish living and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-with-pool-mecklenburg-county",
      "search_query": "apartments with pool Mecklenburg County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Mecklenburg County",
      "h2_subtitle": "Dive into luxury living at The Quincy with a pool in Mecklenburg County. Enjoy exceptional amenities and a vibrant community in Charlotte.",
      "page_copy": "Welcome to The Quincy, where luxury living is redefined in the heart of Mecklenburg County. Our stunning community offers an exquisite pool, providing a refreshing retreat for residents to relax and unwind. Situated in Charlotte’s University City North neighborhood, The Quincy boasts stylish apartments equipped with efficient appliances, luxury flooring, and modern conveniences.\n\nIn addition to our inviting pool, residents can take advantage of our business pods, BBQ/picnic area, and a convenient 2-car garage. Enjoy the ease of access and ample amenities that make our apartments a perfect choice for anyone seeking a balanced lifestyle. Embrace the charm and elegance of living in an apartment with a pool at The Quincy, where community and comfort coexist perfectly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Mecklenburg County",
      "seo_description": "Enjoy luxurious living at The Quincy with a pool in Mecklenburg County. Experience the best of Charlotte in our modern, amenity-rich community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "charlotte-nc-apartments-pickleball-courts",
      "search_query": "Charlotte NC apartments with pickleball courts",
      "category": "Amenity",
      "h1_title": "Charlotte Apartments with Pickleball Courts",
      "h2_subtitle": "Explore Charlotte, NC apartments with pickleball courts at The Quincy. Enjoy vibrant living and community fun in University City North.",
      "page_copy": "Discover an exciting blend of active living and modern convenience at The Quincy in Charlotte, NC. While our community currently focuses on providing superior amenities like efficient appliances, luxury flooring, and a refreshing pool, we’re constantly evolving to meet our residents’ recreational desires, such as adding pickleball courts in the future.\n\nNestled in the charming University City North neighborhood, our community promotes a vibrant lifestyle with amenities like business pods, a BBQ/picnic area, and a 2-car garage, ensuring every resident finds a sense of home and comfort. While pickleball courts aren't available at this moment, The Quincy is committed to expanding its offerings to enhance recreational activities for its residents in the heart of Charlotte, NC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charlotte Apartments with Pickleball Courts",
      "seo_description": "Check out The Quincy in Charlotte, NC - future plans include pickleball courts. Meanwhile, enjoy modern living and diverse amenities in our premium community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-28262",
      "search_query": "apartments with fitness center zip code 28262",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in 28262",
      "h2_subtitle": "Discover apartments with a fitness center in zip code 28262 at The Quincy. Enjoy a healthy lifestyle in Charlotte's University City North.",
      "page_copy": "Elevate your living experience at The Quincy, where health and wellness are at the forefront. Located in zip code 28262, our community provides residents with convenient access to a soon-to-be-added fitness center, perfect for maintaining an active lifestyle. Nestled in the University City North neighborhood of Charlotte, The Quincy offers modern apartments with efficient appliances and luxury flooring that cater to contemporary living.\n\nBeyond personal fitness, our residents enjoy community-focused amenities like business pods, a BBQ/picnic area, and the convenience of a 2-car garage. This harmonious blend of convenience and recreation makes The Quincy the ideal choice for those seeking an active lifestyle in the heart of Charlotte. Join our community and anticipate the exciting addition of a fitness center that will complement the vibrant lifestyle at The Quincy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in 28262",
      "seo_description": "Live at The Quincy in Charlotte's 28262 with plans for a fitness center. Enjoy a healthy lifestyle with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-university-city-north",
      "search_query": "three bedroom apartments university city north",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in University City North",
      "h2_subtitle": "Explore spacious three bedroom apartments in University City North at The Quincy. Ideal for families or roommates looking for comfort and style.",
      "page_copy": "Experience ample living space and modern convenience in the heart of University City North at The Quincy. Our three bedroom apartments offer plenty of room for families, roommates, or anyone desiring extra space. Each unit showcases efficient appliances, luxury flooring, and sophisticated design, ensuring a stylish and functional home.\n\nSituated in Charlotte’s vibrant University City North, The Quincy provides residents with access to a wealth of amenities. Take advantage of our business pods for work-at-home days, enjoy gatherings at our BBQ/picnic area, and benefit from our spacious 2-car garage. Discover the perfect blend of community and privacy in our three bedroom apartments, where convenience and lifestyle meet in the dynamic setting of University City North.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in University City North",
      "seo_description": "Find spacious three bedroom apartments at The Quincy in University City North. Perfect for families or roommates seeking comfort and modern flair.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-near-university-north-carolina-charlotte",
      "search_query": "apartments near university of north carolina charlotte",
      "category": "School",
      "h1_title": "Apartments Near University of North Carolina Charlotte",
      "h2_subtitle": "Find the ideal home at The Quincy, conveniently located near the University of North Carolina Charlotte. Enjoy close proximity and vibrant living.",
      "page_copy": "The Quincy offers the perfect blend of convenience and modern living for those seeking apartments near the University of North Carolina Charlotte. Positioned in the bustling University City North area, our community is ideal for students, faculty, and staff who value proximity to the campus while enjoying the comforts of a premium residential experience.\n\nResidents at The Quincy benefit from thoughtfully designed apartments featuring efficient appliances and luxury flooring. Community amenities, such as business pods, a BBQ/picnic area, and a 2-car garage, enhance the living experience, creating a vibrant atmosphere. Whether you're attending classes, working on campus, or simply wish to be part of an energetic neighborhood, The Quincy provides the ideal home base in close reach of UNC Charlotte.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of North Carolina Charlotte",
      "seo_description": "Discover convenient living at The Quincy, near UNC Charlotte. Enjoy modern apartments and vibrant community life just minutes from campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-near-atrium-health-university-city",
      "search_query": "apartments near Atrium Health University City Charlotte NC",
      "category": "Hospital",
      "h1_title": "Apartments Near Atrium Health University City NC",
      "h2_subtitle": "Discover convenient living at The Quincy, located near Atrium Health University City in Charlotte, NC. Ideal for healthcare professionals.",
      "page_copy": "The Quincy is the prime choice for those seeking apartments near Atrium Health University City in Charlotte, NC. Situated in the University City North neighborhood, our community is perfect for healthcare professionals, patients, and families who need easy access to Atrium Health facilities while enjoying a comfortable living environment.\n\nOur apartments feature efficient appliances and elegant luxury flooring, making them ideal for both relaxation and work-from-home arrangements. The Quincy provides amenities such as business pods, a BBQ/picnic area, and a 2-car garage, enhancing community life. Choose The Quincy for a blend of proximity and peace, where the hustle and bustle of work meets the tranquility of home, all in the vibrant area of University City North.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atrium Health University City NC",
      "seo_description": "Live at The Quincy, close to Atrium Health University City in Charlotte. Ideal apartments for healthcare staff and those needing healthcare access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-near-reedy-creek-nature-preserve",
      "search_query": "apartments near reedy creek nature preserve charlotte",
      "category": "Park",
      "h1_title": "Apartments Near Reedy Creek Nature Preserve",
      "h2_subtitle": "Explore life at The Quincy, located near Reedy Creek Nature Preserve. Enjoy the perfect blend of city living and natural beauty in Charlotte.",
      "page_copy": "Find your home at The Quincy, ideally situated for nature lovers in Charlotte, NC. Just a short drive from the beautiful Reedy Creek Nature Preserve, our apartments offer easy access to serene walking trails and outdoor adventures, ideal for anyone seeking recreation in nature’s embrace.\n\nResidents of The Quincy enjoy modern amenities such as efficient appliances, luxury flooring, and an accommodating 2-car garage. With business pods and a welcoming BBQ/picnic area, our community provides comfort and convenience. Choose The Quincy to enjoy a refreshing balance of urban amenities and natural beauty, with the lively University City North area just moments away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Reedy Creek Nature Preserve",
      "seo_description": "Discover The Quincy, near Reedy Creek Nature Preserve. Perfect apartments for those who love nature and vibrant living in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "harrisburg-park-apartments-mecklenburg-county",
      "search_query": "harrisburg park apartments mecklenburg county",
      "category": "Park",
      "h1_title": "Harrisburg Park Apartments in Mecklenburg County",
      "h2_subtitle": "Experience life at The Quincy, near Harrisburg Park in Mecklenburg County. Enjoy modern amenities and a vibrant community environment.",
      "page_copy": "Welcome to The Quincy, the ideal choice for those seeking Harrisburg Park apartments in Mecklenburg County. Nestled in the lively University City North, our community offers easy access to the charming outdoor spaces of Harrisburg Park, perfect for picnics, sports, and leisurely walks.\n\nAt The Quincy, residents enjoy an array of luxurious amenities including efficient appliances, luxury flooring, and spacious 2-car garages. The community boasts modern conveniences such as business pods and a BBQ/picnic area, making it an attractive option for those who desire a dynamic lifestyle. Discover the best of both worlds—proximity to natural beauty and the vibrancy of Mecklenburg County—at The Quincy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Harrisburg Park Apartments in Mecklenburg County",
      "seo_description": "Live at The Quincy, near Harrisburg Park in Mecklenburg County. Enjoy luxury living with modern amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "unc-charlotte-botanical-gardens-apartments",
      "search_query": "unc charlotte botanical gardens nearby apartments",
      "category": "Park",
      "h1_title": "Nearby Apartments to UNC Charlotte Botanical Gardens",
      "h2_subtitle": "Discover The Quincy, offering close proximity to the UNC Charlotte Botanical Gardens. Enjoy serene living with urban perks in Charlotte.",
      "page_copy": "The Quincy provides the perfect setting for those searching for UNC Charlotte Botanical Gardens nearby apartments. Located in Charlotte's University City North, our community offers quick access to the gardens' stunning collection of flora and tranquil pathways, ideal for a refreshing escape into nature.\n\nResidents enjoy a suite of modern amenities at The Quincy, including efficient appliances and luxury flooring that enhance your living experience. The community features business pods and a BBQ/picnic area, ensuring a relaxing and productive environment. With the splendor of the UNC Charlotte Botanical Gardens just around the corner, experience the harmony of nature and urban sophistication at The Quincy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "UNC Charlotte Botanical Gardens Nearby Apartments",
      "seo_description": "Find The Quincy near UNC Charlotte Botanical Gardens. Ideal apartments for nature lovers seeking urban convenience in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "nevin-park-apartments-university-city-north",
      "search_query": "nevin park apartments university city north",
      "category": "Park",
      "h1_title": "Nevin Park Apartments in University City North",
      "h2_subtitle": "Live at The Quincy, near Nevin Park. Enjoy University City North's vibrant lifestyle and unmatched amenities.",
      "page_copy": "Welcome to The Quincy, an excellent choice for those looking for Nevin Park apartments in University City North. Situated in a vibrant area of Charlotte, our community enjoys proximity to Nevin Park, a perfect spot for outdoor fun, sports, and relaxation.\n\nAt The Quincy, residents delight in a wide range of amenities including efficient appliances, upscale luxury flooring, and the comfort of a spacious 2-car garage. Our community features business pods and a BBQ/picnic area, fostering both productivity and relaxation. Experience the lively atmosphere of University City North, complemented by easy access to Nevin Park, here at The Quincy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nevin Park Apartments in University City North",
      "seo_description": "Discover The Quincy near Nevin Park in University City North. Enjoy modern amenities and recreational convenience in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-near-unc-charlotte-main-station",
      "search_query": "apartments near UNC Charlotte Main Station",
      "category": "Transit",
      "h1_title": "Apartments Near UNC Charlotte Main Station",
      "h2_subtitle": "Discover The Quincy, located conveniently near UNC Charlotte Main Station. Enjoy seamless transit and contemporary living in Charlotte.",
      "page_copy": "For those searching for apartments near UNC Charlotte Main Station, The Quincy offers unmatched convenience and modern living in University City North. Our location ensures quick access to transit options, making daily commutes and city exploration a breeze.\n\nResidents at The Quincy enjoy features such as efficient appliances, luxury flooring, and ample 2-car garages. The community is designed with amenities like business pods and a BBQ/picnic area, catering to both productivity and leisure. With the UNC Charlotte Main Station nearby, enjoy the benefits of an accessible lifestyle wrapped in comfort and style at The Quincy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UNC Charlotte Main Station",
      "seo_description": "Live at The Quincy, conveniently near UNC Charlotte Main Station. Enjoy easy transit access and modern amenities in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "apartments-close-to-old-concord-road-station-nc",
      "search_query": "apartments close to Old Concord Road Station NC",
      "category": "Transit",
      "h1_title": "Apartments Close to Old Concord Road Station NC",
      "h2_subtitle": "Explore The Quincy, located close to Old Concord Road Station in NC. Perfect for those seeking easy commuting and modern amenities.",
      "page_copy": "The Quincy offers ideal apartments close to Old Concord Road Station NC, making it an excellent choice for commuters in University City North, Charlotte. With easy access to public transportation, residents can seamlessly connect to the city's vibrant lifestyle.\n\nThe community boasts features designed for comfort and convenience, including efficient appliances, luxurious flooring, and a spacious 2-car garage. Our amenities cater to diverse needs with business pods and a BBQ/picnic area, perfect for both work and relaxation. Experience a connected lifestyle without compromising on style and comfort at The Quincy, just steps away from Old Concord Road Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Old Concord Road Station NC",
      "seo_description": "Find comfort at The Quincy near Old Concord Road Station NC. Perfect apartments with modern amenities and easy commute options in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167640",
      "source": "generator",
      "page_item_url": "university-city-blvd-transit-accessible-apartments-charlotte",
      "search_query": "University City Blvd transit accessible apartments Charlotte",
      "category": "Transit",
      "h1_title": "Transit Accessible Apartments on University City Blvd",
      "h2_subtitle": "Discover The Quincy, where University City Blvd transit access meets modern comfort in Charlotte. Ideal for those prioritizing connectivity.",
      "page_copy": "If you're seeking transit accessible apartments on University City Blvd in Charlotte, The Quincy is your perfect match. Situated in University City North, our location ensures effortless access to public transportation, making city commutes and exploration convenient.\n\nAt The Quincy, you’ll find a community designed with modern living in mind. Our amenities include efficient appliances, luxury flooring, and a generous 2-car garage. Enjoy the benefits of business pods for your professional needs and a BBQ/picnic area for leisure. Experience the ultimate in connectivity and comfort at The Quincy, perfectly positioned on University City Blvd.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
      "featured_image_media": {
        "alt_text": "Family moving into The Quincy apartments, carrying boxes and plants.",
        "public_id": "019fec30-b75d-75a0-b6ed-73a52404d2d8",
        "storage_key": "property/6767906449167640/019fec30-b75d-75a0-b6ed-73a52404d2d8.webp",
        "width": 1920,
        "height": 450
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Transit Accessible Apartments on University City Blvd",
      "seo_description": "Live at The Quincy on University City Blvd. Experience transit-friendly living with modern amenities in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977275370"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MGBRX3G3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://live-quincy.fatwin.com/api/websites/resources/1?x=Mmx2NGE3OTVhamUzMGkwU2w3bFpmQjBnTmlDVTZkUTRxd2VLU21jT0orQ2dxKzUvbjFPYnVON04reUsyOEpGN3kzZHk0L1RTL1UraTZwUUlxTFJsS0E9PQ2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywy8xlgvq0"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a683ebf8-1f3e-11f1-bfdf-3f68d1d1ad93"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977275370",
  "custom_google_gtm_id": "GTM-MGBRX3G3",
  "custom_rollout_phase": "Phase 2",
  "custom_perq_script_url": "https://live-quincy.fatwin.com/api/websites/resources/1?x=Mmx2NGE3OTVhamUzMGkwU2w3bFpmQjBnTmlDVTZkUTRxd2VLU21jT0orQ2dxKzUvbjFPYnVON04reUsyOEpGN3kzZHk0L1RTL1UraTZwUUlxTFJsS0E9PQ2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywy8xlgvq0",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "a683ebf8-1f3e-11f1-bfdf-3f68d1d1ad93",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_audioeye_site_id": "c3557026-f034-4492-8200-f92b90135ee8",
  "custom_audioeye_site_hash": "fda7dd7f846ddc5102b6e55c376fc1b7"
};

export const generatedAt = '2026-10-29T18:33:29.909Z';
